export function isUserLoggedIn(state) {
  return state.user.isLoggedIn;
}

export function isUserSubscribed(state) {
  return state.user.isSubscribed;
}

export function isCheckingStatus(state) {
  return state.user.isCheckingUserStatus;
}

export function getUsername(state) {
  return state.user.username;
}

export function getEmail(state) {
  return state.user.email;
}

export function getCompanyName(state) {
  return state.user.companyName;
}

export function getTestGroupNumber(state) {
  return state.user.testGroupNumber;
}



// WEBPACK FOOTER //
// ./src/selectors/user.js